import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';
import { toast } from 'react-toastify';
import { formatDate } from '../utils/helpers';
import FetchApi from '../api/getAxios';

export const SalesContext = React.createContext();


export const SalesProvider = ({ children }) => {

    const [salesItem, setSalesItem] = useState([]);
    const [salesItemLoading, setSalesItemLoading] = useState(false);

    const { btoken, stoken, usertoken } = useUserContext();

    let data = { btoken, stoken, usertoken };

    const {
        loading: salesLoading, data: salesData, fetchData: getSalesData
    } = useFetch('/sales.home', data);

    const {
        loading: allSalesLoading, data: allSales, fetchData: getAllSalesData
    } = useFetch('/getSalesRecords', data);


    // Get Sales Item Data
    const getSalesItem = async (invid) => {
        setSalesItemLoading(true);
        const data = {
            btoken, stoken, invid
        };
        FetchApi.post(`/getSalesData`, data)
            .then((res) => {
                if (res.success === false) {
                    setSalesItemLoading(false);
                    toast.warn(res.message);
                } else {
                    setSalesItemLoading(false);
                    setSalesItem(res.data);
                }
            })
            .catch(() => {
                setSalesItemLoading(false);
            });
    };
    // Get Sales Item Data





    // Sales Type Function
    const [type, settype] = useState('product');

    function changeType(e) {
        settype(e);
        if (e === 'service') {
            toast.success('You have selected Services');
        }
        if (e === 'product') {
            toast.success('You have selected Products');
        }
    }
    // Sales Type Function

    // Order Fields

    const [orderField, setOrderField] = useState({
        sales_time: `${ formatDate(new Date()) }`,
        customer_name: "",
        customer_mail: "",
        customer_phone: "",
        details: "",
        pay_mode: "",
        vat_type: "",
    });

    function handleOrderField(e) {
        setOrderField((inputs) => ({
            ...inputs,
            [e.target.name]: e.target.value
        }));
    }
    // Order Fields

    // Confirm Sales
    const [showConfirmSales, setShowConfirmSales] = useState(false);
    const closeConfirmSales = () => setShowConfirmSales(false);
    const openConfirmSales = () => setShowConfirmSales(true);
    // Confirm Sales

    return (
        <SalesContext.Provider value={{

            salesLoading, salesData, getSalesData,

            allSalesLoading, allSales, getAllSalesData,

            salesItemLoading, salesItem, getSalesItem,

            changeType, type,

            orderField, handleOrderField, setOrderField,


            showConfirmSales, closeConfirmSales, openConfirmSales,


        }}>
            {children}
        </SalesContext.Provider>
    );
};

// make sure use
export const useSalesContext = () => {
    return useContext(SalesContext);
};
